import { SHOPIFY_DOMAIN } from '../../constants';

const constructUrl = (clientSLD, clientId, scopes, redirectUri, nonce, accessMode) => `https://${clientSLD}.${SHOPIFY_DOMAIN}/admin/oauth/authorize?client_id=${clientId}&scope=${scopes}&redirect_uri=${redirectUri}&state=${nonce}&grant_options[]=${accessMode}`;

export default constructUrl;
